import Icon from '@components/icons/Icon';
import styles from '@features/cms/components/pages/MultiIconBlock/IconSingle/IconSingle.styles';
import { IMultiIconSingle } from '@features/cms/typescript';
import Heading from '@components/Heading/Heading';
import theme from '@styles/theme';
import sanitizeHtml from '@utils/sanitizeHtml';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  iconSingle: IMultiIconSingle;
  color: string;
};
const IconSingle = ({
  iconSingle,
  color
}: PropsType) => {
  const {
    text,
    hex,
    icon,
    image,
    border,
    variant,
    isImageIcon
  } = iconSingle;
  const renderIcon = () => {
    if (image && image.path) {
      return <div sx={styles.imageIcon(border, isImageIcon, color)}>
          <ResponsiveImage image={image.path} alt={image.metadata.alt || text} />
        </div>;
    }
    if (icon) {
      return <Icon icon={icon} color={color || theme.rawColors.neutralBlack} size="60px" />;
    }
    if (hex) {
      return <div sx={styles.hexIcon(hex, border, color)} />;
    }
    return null;
  };
  return <div sx={styles.iconBox(variant)} data-testid="IconSingle-iconBox">
      {renderIcon()}
      <Heading h={5} headingType={5} mobile color={color || theme.rawColors.neutralBlack} dangerouslySetInnerHTML={sanitizeHtml(text)} />
    </div>;
};
export default IconSingle;